import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { RootState } from "../../redux/store";
import PaymentsIcon from "@mui/icons-material/Payments"; // 💰 gold payout icon

const PayoutAgreement: React.FC = () => {
  const user = useSelector((state: RootState) => state.auth.user);
  const navigate = useNavigate();

  if (!user) return <div style={{ padding: 40 }}>Loading...</div>;

  const handleRedirect = () => {
    navigate(`/PaymentMethodDashboard/${user.userId}`);
  };

  return (
    <div style={styles.card}>
      <div style={styles.iconWrapper}>
        <PaymentsIcon sx={{ fontSize: 40, color: "#308fbfff" }} />
      </div>

      <h2 style={styles.title}>Set Up Your Payouts</h2>
      <p style={styles.subtext}>
        Before receiving any earnings, you need to add a payout method. <br />
        This ensures secure and timely transfers to your account.
      </p>

      <button style={styles.button} onClick={handleRedirect}>
        Add Your Payout Method
      </button>
    </div>
  );
};

export default PayoutAgreement;

const styles: { [key: string]: React.CSSProperties } = {
  card: {
    background: "#000",
    border: "1.5px solid #308fbfff", // dark gold outline
    borderRadius: 16,
    padding: "32px 24px",
    maxWidth: 500,
    margin: "40px auto",
    textAlign: "center",
    color: "#fff",
    boxShadow: "0 0 20px rgba(191,155,48,0.1)",
  },
  iconWrapper: {
    width: 70,
    height: 70,
    margin: "0 auto 16px",
    borderRadius: "50%",
    background: "linear-gradient(135deg, #308fbfff, rgba(32, 122, 122, 1)ff)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 0 10px rgba(48, 160, 191, 0.4)",
  },
  title: {
    fontSize: "1.6rem",
    fontWeight: "bold",
    marginBottom: 12,
  },
  subtext: {
    fontSize: "1rem",
    color: "#ccc",
    marginBottom: 24,
    lineHeight: 1.5,
  },
  button: {
    backgroundColor: "#000",
    color: "#00c3ffff",
    padding: "12px 26px",
    fontSize: "1rem",
    fontWeight: 600,
    borderRadius: 10,
    border: "1.5px solid #00c3ffff",
    cursor: "pointer",
    transition: "all 0.3s ease",
  },
};
